export const RECONCILIATION_FORM_STATUS = {
    INCOMPLETE: "Incomplete",
    COMPLETED: "Completed",
}

export const SELECT_PAYMENT_FREQUENCY = "Please Select a Payment Frequency";
export const FREQUENCY_POPUP_HEADER = "How often do you pay State Withholding?";

export const RECONCILIATION_LOADING_STATES = {
    GRID_LOADING: "GRID_LOADING",
    GRID_READY: "GRID_READY",
    STATES_FILTER_LOADING: "STATES_FILTER_LOADING",
    STATES_FILTER_READY: "STATES_FILTER_READY",
    DOWNLOAD_UNSUBMITTED_STATE_RECONCILLIATION_FORM_LOADING: "DOWNLOAD_UNSUBMITTED_STATE_RECONCILLIATION_FORM_LOADING", 
    DOWNLOAD_UNSUBMITTED_STATE_RECONCILLIATION_FORM_READY: "DOWNLOAD_UNSUBMITTED_STATE_RECONCILLIATION_FORM_READY", 
    CHECK_IF_SELECTED_FORMS_COMBINATION_ALLOWED_LOADING: "CHECK_IF_SELECTED_FORMS_COMBINATION_ALLOWED_LOADING", 
    CHECK_IF_SELECTED_FORMS_COMBINATION_ALLOWED_READY: "CHECK_IF_SELECTED_FORMS_COMBINATION_ALLOWED_READY", 
}

export const RECONCILIATION_LOADING_STATES_MESSAGE_MAP = {
    [RECONCILIATION_LOADING_STATES.GRID_LOADING]: "",
    [RECONCILIATION_LOADING_STATES.STATES_FILTER_LOADING]: "",
    [RECONCILIATION_LOADING_STATES.DOWNLOAD_UNSUBMITTED_STATE_RECONCILLIATION_FORM_LOADING]: "",
    [RECONCILIATION_LOADING_STATES.CHECK_IF_SELECTED_FORMS_COMBINATION_ALLOWED_LOADING]: "",
}